import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { Subject, filter, map } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HubService {
  private connection: HubConnection;
  private groups = new Set<string>();
  lastHash: string;
  private message$ = new Subject<any>();

  constructor(@Inject(PLATFORM_ID) private platformId) {
    if (isPlatformBrowser(this.platformId)) this.start();
  }

  async start() {
    if (this.connection?.state === HubConnectionState.Connected) return;
    this.stop();
    try {
      this.connection = new HubConnectionBuilder()
        .withUrl("/hub")
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

      this.connection.onreconnected(() => this.join());
      this.connection.onclose(async () => await this.start());
      this.connection.on('ReceiveMessage', (message) => {
        if (this.lastHash && this.lastHash === message.hash) return;
        console.log('Received message: ', message);
        this.message$.next(message);
        this.lastHash = message.hash;
      });

      try {
        await this.connection.start();
        this.join();
      } catch (err) {
        console.log(err);
        setTimeout(this.start, 5000);
      }
    } catch (e) { console.error(e); }
  }

  on<T>(...types: string[]) {
    return this.message$
      .pipe(
        // takeUntilDestroyed(),
        filter(message => types.includes(message.type)),
        map(message => message.data as T)
      );
  }


  async stop() {
    try { if (this.connection?.state === HubConnectionState.Connected) await this.connection.stop(); }
    catch (e) { console.error(e); }
  }

  join(...group: string[]) {
    if (group.length > 0) this.groups = new Set([...this.groups, ...group]);
    if (this.groups.size && this.connection?.state === HubConnectionState.Connected)
      this.connection.invoke('JoinGroup', Array.from(this.groups));
  }
  leave(group: string) {
    this.groups.delete(group);
    if (this.connection?.state === HubConnectionState.Connected)
      this.connection.invoke('LeaveGroup', group);
  }
}